import "./PostJob.css";
import NavBar from "../../Navbar";
import { useEffect, useState } from "react";
import { edit_job, upload_img_to_database } from "../../../utilities/apis";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ModalPg from "../../ModalPg/ModalPg";
import { Alert, Slide } from "@mui/material";




const PostJobEx = () => {
  const selectUserID = useSelector((state) => state.user.userID);
  const initialState = {
    user_id: selectUserID,
    job_title: "",
    job_description: "",
    salary_compensation: "",
    location: "",
    benefits: "",
    city: "",
    preferred_qualification: "",
    company_information: "",
    deadline: "",
    work_schedule: "",
    contact_information: "",
    company_logo: null,
    experience: "",
    req_skills: "",
  };

  const navigate = useNavigate();
  const [userState, setUserState] = useState(initialState);
  const [errors, setErrors] = useState({});
  const selectUserRole = useSelector((state) => state.user.userRole);
  const jobs = useSelector((state) => state.user.jobArray);
  const jobId = useSelector((state) => state.user.editJobId);
  const isEdit = useSelector((state) => state.user.forEdit);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sendAlert, SetSendAlert] = useState(false)

  const validateFields = () => {
    let isValid = true;
    const newErrors = {};

    // Validate job_title
    if (!userState.job_title.trim()) {
      newErrors.job_title = "Job Title is required";
      isValid = false;
    }

    // Validate job_description
    if (!userState.job_description.trim()) {
      newErrors.job_description = "Job Description is required";
      isValid = false;
    }

    // Validate salary_compensation
    if (!userState.salary_compensation.trim()) {
      newErrors.salary_compensation = "Salary Compensation is required";
      isValid = false;
    }

    // Validate location
    if (!userState.location.trim()) {
      newErrors.location = "Location is required";
      isValid = false;
    }

    // Validate city
    if (!userState.city.trim()) {
      newErrors.city = "City is required";
      isValid = false;
    }


    // Validate skills
    if (!userState.req_skills.trim()) {
      newErrors.req_skills = "skills is required"
      isValid = false;
    }

    //validate company information
    if (!userState.company_information.trim()) {
      newErrors.company_information = 'Company information is required'
      isValid = false;
    }

    // validate experiance
    if (!userState.experience.trim()) {
      newErrors.experience = 'experiance is required'
      isValid = false;
    }

    // Validate work-mode
    // if (!userState.work_mode) {
    //   newErrors.work_mode = "Work Mode is required";
    //   isValid = false;
    // }

    // Validate preferred_qualification
    // if (!userState.preferred_qualification.trim()) {
    //   newErrors.preferred_qualification = "Preferred Qualification is required";
    //   isValid = false;
    // }

    setErrors(newErrors);
    return isValid;
  };

  useEffect(() => {
    console.log("Edit", isEdit);
    if (isEdit) {
      try {
        const jobToEdit = jobs.find((job) => job.job_id === jobId);
        console.log("(Edit Page)Job To Edit: ", jobToEdit);
        setUserState((prevState) => ({
          ...prevState,
          ...jobToEdit,
        }));
      } catch (error) {
        console.log("(Edit Page)Error: ", error);
      }
    } else {
      setUserState((prev) => ({
        ...prev,
        job_title: "",
        job_description: "",
        salary_compensation: "",
        location: "",
        benefits: "",
        city: "",
        preferred_qualification: "",
        company_information: "",
        deadline: "",
        req_skills: "",
        contact_information: "",
        company_logo: null,
      }));
    }
  }, [isEdit, jobId, jobs]);

  useEffect(() => {
    console.log(userState);
  }, [userState]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    // Optionally clear errors for this field
    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: null,
      }));
    }
  };

  const handleFile = (e) => {
    if (e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      setUserState((prev) => ({
        ...prev,
        company_logo: selectedFile,
      }));
    } else {
      setUserState((prev) => ({
        ...prev,
        company_logo: null,
      }));
    }
  };

  useEffect(() => {
    setTimeout(() => {
      SetSendAlert(false);
    }, 3000);
  }, [sendAlert]);


  const handleImageUpload = async (e) => {
    e.preventDefault();
    if (validateFields()) {
      // Proceed with API call
      if (isEdit) {
        try {

          const editFormData = new FormData();
          editFormData.append("jobId", userState.job_id)
          editFormData.append("userRole", selectUserRole)
          Object.keys(userState).forEach((key) => {
            editFormData.append(key, userState[key]);
          })
          const editRes = await edit_job(editFormData);
          console.log(editRes);
          if (editRes.success) {
            // alert("Job updated Successfully.")
            SetSendAlert(true);
            setTimeout(() => {
              navigate("/home")
            }, 2000)

          }
        } catch (error) {
          console.log("Error updating job");
          console.error("Error: ", error);
        }
      }

      if (!isEdit) {
        setIsModalOpen(true);
        const formData = new FormData();
        Object.keys(userState).forEach((key) => {
          formData.append(key, userState[key]);
        });

        upload_img_to_database(formData)
          .then(() => {
            console.log("Upload successful");
            setUserState(initialState);
            setErrors({});
            // SetSendAlert(true);
          })
          .catch((error) => {
            console.error("Error uploading image:", error);
            alert("Retry");
          });
      }
    } else {
      console.log("Form validation failed");
    }
  };

  const handleNoClk = () => {
    setIsModalOpen(false);
    navigate("/home");
  }

  const handleYesClk = () => {
    setIsModalOpen(false);
  }


  return (
    <>
      <NavBar logOutFlag={true} />
      <div>
        <ModalPg handleNoClk={handleNoClk} handleYesClk={handleYesClk} isOpen={isModalOpen} title="Job created succesfully!" description="Do you want to add more jobs?"> </ModalPg>
      </div>
      <Slide in={sendAlert} direction="up">
        {/* Alert component to display success message */}
        <Alert variant="filled" severity="success">
          updated succesfully
        </Alert>
      </Slide>

      <div className='postjob-container mt-5'>
        <div className='form-container p-5'>
          <form className='row g-3'>
            <div className='col-md-4'>
              <label htmlFor='inputJobTitle' className='form-label'>
                Job Title*
              </label>
              <input
                type='text'
                name='job_title'
                value={userState.job_title}
                className={`form-control form-control-post ${errors.job_title ? "is-invalid" : ""}`}
                id='inputJobTitle'
                onChange={handleChange}
              />
              {errors.job_title && <div className='invalid-feedback'>{errors.job_title}</div>}
            </div>

            <div className='col-md-4'>
              <label htmlFor='inputSalaryCompensation' className='form-label'>
                Salary Compensation*
              </label>
              <input
                type='text'
                name='salary_compensation'
                value={userState.salary_compensation}
                className={`form-control form-control-post ${errors.salary_compensation ? "is-invalid" : ""}`}
                id='inputSalaryCompensation'
                onChange={handleChange}
              />
              {errors.salary_compensation && <div className='invalid-feedback'>{errors.salary_compensation}</div>}
            </div>

            <div className='col-md-4'>
              <label htmlFor='inputBenefits' className='form-label'>
                Benefits
              </label>
              <input
                type='text'
                name='benefits'
                value={userState.benefits}
                className={`form-control form-control-post ${errors.benefits ? "is-invalid" : ""}`}
                id='inputBenefits'
                onChange={handleChange}
              />
              {errors.benefits && <div className='invalid-feedback'>{errors.benefits}</div>}
            </div>

            <div className='col-4'>
              <label htmlFor='inputJobDescription' className='form-label'>
                Job Description*
              </label>
              <textarea
                type='text'
                name='job_description'
                // minRows={3}
                value={userState.job_description}
                style={{ width: '100%' }}
                className={`form-control form-control-post ${errors.job_description ? "is-invalid" : ""}`}
                id='inputjob_description'
                onChange={handleChange}
              />
              {errors.job_description && <div className='invalid-feedback'>{errors.job_description}</div>}

            </div>
            <div className='col-md-4'>
              <div className='col-md-12'>
                <label htmlFor='inputCity' className='form-label'>
                  Preferred Qualifiaction
                </label>
                <input
                  type='text'
                  name='preferred_qualification'
                  value={userState.preferred_qualification}
                  className={`form-control form-control-post`}
                  id='inputCity'
                  onChange={handleChange}
                />
                {/* {errors.preferred_qualification && <div className='invalid-feedback'>{errors.preferred_qualification}</div>} */}
              </div>
              <div className='col-md-12 mt-2'>
                <label htmlFor='inpuContactInformation' className='form-label'>
                  Required Experience*
                </label>
                <input
                  type='text'
                  name='experience'
                  value={userState.experience}
                  className={`form-control form-control-post ${errors.experience ? "is-invalid" : ""}`}
                  id='inpuContactInformation'
                  onChange={handleChange}
                />
                {errors.experience && <div className='invalid-feedback'>{errors.experience}</div>}
              </div>
            </div>
            <div className='col-md-4'>
              <label htmlFor='inputWorkSchedule' className='form-label'>
                Required Skills*
              </label>
              <textarea
                type='text'
                name='req_skills'
                value={userState.req_skills}
                // minRows={3}
                className={`form-control form-control-post ${errors.req_skills ? "is-invalid" : ""}`}
                id='inputWorkSchedule'
                onChange={handleChange}
              />
              {errors.req_skills && <div className='invalid-feedback'>{errors.req_skills}</div>}
            </div>

            <div className='col-md-4'>
              <label htmlFor='inputCompanyInformation' className='form-label'>
                Company Information*
              </label>
              <input
                type='text'
                name='company_information'
                value={userState.company_information}
                className={`form-control form-control-post ${errors.company_information ? "is-invalid" : ""}`}
                id='inputCompanyInformation'
                onChange={handleChange}
              />

              {errors.company_information && <div className='invalid-feedback'>{errors.company_information}</div>}
            </div>

            <div className='col-md-4'>
              <label htmlFor='inputDeadLine' className='form-label'>
                Dead Line
              </label>
              <input
                type='text'
                name='deadline'
                value={userState.deadline}
                className={`form-control form-control-post ${errors.deadline ? "is-invalid" : ""}`}
                id='inputDeadLine'
                onChange={handleChange}
              />
              {errors.deadline && <div className='invalid-feedback'>{errors.deadline}</div>}
            </div>

            <div className='col-md-2'>
              <label htmlFor='inputLocation' className='form-label'>
                Location*
              </label>
              <input
                type='text'
                name='location'
                value={userState.location}
                className={`form-control form-control-post ${errors.location ? "is-invalid" : ""}`}
                id='inputLocation'
                onChange={handleChange}
              />
              {errors.location && <div className='invalid-feedback'>{errors.location}</div>}
            </div>

            <div className='col-md-2'>
              <label htmlFor='inputCity' className='form-label'>
                City*
              </label>
              <input
                type='text'
                name='city'
                value={userState.city}
                className={`form-control form-control-post ${errors.city ? "is-invalid" : ""}`}
                id='inputCity'
                onChange={handleChange}
              />
              {errors.city && <div className='invalid-feedback'>{errors.city}</div>}
            </div>

            <div className='col-md-4'>
              <label htmlFor='inpuContactInformation' className='form-label'>
                Contact Information
              </label>
              <input
                type='text'
                name='contact_information'
                value={userState.contact_information}
                className={`form-control form-control-post ${errors.contact_information ? "is-invalid" : ""}`}
                id='inpuContactInformation'
                onChange={handleChange}
              />
              {errors.contact_information && <div className='invalid-feedback'>{errors.contact_information}</div>}
            </div>

            <div className='col-md-4 d-flex flex-column align-items-center'>
              <label htmlFor='btnGroup' className='form-label col-md-12'>
                Work Mode:
              </label>

              <div className='btn-group' role='group' aria-label='Basic checkbox toggle button group'>
                <input type='radio' name='work-mode' value='Remote' className='btn-check' id='btncheck1' onChange={handleChange} />
                <label className='btn btn-outline-primary btnjp' htmlFor='btncheck1'>
                  Remote
                </label>

                <input type='radio' name='work-mode' value='Onsite' className='btn-check' id='btncheck2' onChange={handleChange} />
                <label className='btn btn-outline-primary btnjp' htmlFor='btncheck2'>
                  OnSite
                </label>
              </div>
            </div>
            <div className='col-md-4'>
              <label htmlFor='btnGroup' className={`form-label col-md-12 ${errors.work_mode ? "is-invalid" : ""}`}>
                Work Type:
              </label>
              <div className='btn-group' role='group' aria-label='Basic radio toggle button group'>
                <input type='radio' className='btn-check' name='work-schedule' value='Full Time' id='btnradio1' onChange={handleChange} />
                <label className='btn btn-outline-primary btnjp' htmlFor='btnradio1'>
                  Full Time
                </label>

                <input type='radio' className='btn-check' name='work-schedule' value='Part Time' id='btnradio2' onChange={handleChange} />
                <label className='btn btn-outline-primary btnjp' htmlFor='btnradio2'>
                  Part Time
                </label>

                <input type='radio' className='btn-check' name='work-schedule' value='Consultant' id='btnradio3' onChange={handleChange} />
                <label className='btn btn-outline-primary btnjp' htmlFor='btnradio3'>
                  Consultant
                </label>
              </div>
              {errors.work_mode && <div className='invalid-feedback'>{errors.work_mode}</div>}
            </div>

            {/* <div className='col-md-4'>
              <label htmlFor='inpuContactInformation' className='form-label'>
                Required Experience*
              </label>
              <input
                type='text'
                name='experience'
                value={userState.experience}
                className={`form-control form-control-post ${errors.experience ? "is-invalid" : ""}`}
                id='inpuContactInformation'
                onChange={handleChange}
              />
              {errors.experience && <div className='invalid-feedback'>{errors.experience}</div>}
            </div> */}
            <div className='col-md-12 d-flex   pt-4 align-items-center justify-content-center'>
              <label htmlFor='upload-image' className="col-5 text-end">Upload Logo</label>
              <input id='upload-image' name='upload-image' type='file' accept='image/*' onChange={handleFile} className="col-7 px-4" />
            </div>

            <div className='col-12 d-flex justify-content-center align-items-center pt-4'>
              <button type='button' value='submit form' className='btn btn-primary btnJob' onClick={handleImageUpload}>
                {isEdit ? "Update" : "Create"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default PostJobEx;
